module.exports = __webpack_public_path__ + "static/media/bannerHomeCadastro.c16505af.png";